export default __webpack_public_path__ + "static/media/myjourney-bluetree-fruit.c71b591d.svg";